import React from 'react';

const Uganda1_advanced_secondary_math = () => {
  return (
    <div>
      
    </div>
  );
}

export default Uganda1_advanced_secondary_math;
